import { render, staticRenderFns } from "./OtrosPerView.vue?vue&type=template&id=e6ea9e5e&scoped=true"
import script from "./OtrosPerView.vue?vue&type=script&lang=js"
export * from "./OtrosPerView.vue?vue&type=script&lang=js"
import style1 from "./OtrosPerView.vue?vue&type=style&index=1&id=e6ea9e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ea9e5e",
  null
  
)

export default component.exports